<template>
    <v-flex xs6>
        <ul>
            <li v-for="service in services"><h2>{{service.service}}</h2></li>
        </ul>
    </v-flex>
</template>

<script>
    export default {
        name: 'ServiceList',
        props: ['services']
    }
</script>

<style>
</style>
